import { useMutation } from '@tanstack/react-query';
import logErrorWithContext from '@hmhco/client-monitoring/src/context/logErrorWithContext';
import { submitEarlyAccessRegistration } from '../api/earlyAccessRegistrationApi';

/**
 * TanStack Query mutation hook to submit the Early Access create user form.
 * e.g. const { mutateAsync } = useSubmitEarlyAccessRegistration();
 *
 * @returns {Object} Mutation state and methods
 */
const useSubmitEarlyAccessRegistration = () =>
  useMutation({
    mutationFn: submitEarlyAccessRegistration,
    onError: (error, variables) => {
      logErrorWithContext(
        'Login app - Error submitting early-access registration',
        [
          { key: 'errorMessage', value: error?.message },
          { key: 'orgRefId', value: variables?.orgRefId },
        ],
      );
    },
  });

export default useSubmitEarlyAccessRegistration;
